import { addStyles } from 'ethcss'
import { IStyles, mediaCSS } from 'theme'
import { colors } from 'theme/colors'

const fileManager: IStyles = {
    fileManager: {
        position: 'absolute',
        top: 52,
        left: 0,
        right: 0,
        padding: '0 50px',
        background: '#272727',
        width: '100%',
        height: 'calc(100% - 78px)',
        overflow: 'hidden',

        [mediaCSS.tab]: {
            top: 94,
            height: 'calc(100% - 100px)',
        },
    },
    tableWrapper: {
        maxHeight: 'calc(100% - 60px)',
        minHeight: 'calc(100% - 60px)',
        overflow: 'auto',
        marginTop: 30,
    },
    filesTable: {
        width: '100%',
        color: colors.white,

        th: {
            position: 'relative',
            backgroundColor: '#141414',
            padding: 10,
            textAlign: 'left',
            borderRight: '1px solid #272727',
            verticalAlign: 'middle',

            '&:first-child': {
                width: 38,
            },

            '&:nth-child(2)': {
                width: '70%',
            },
            '&:nth-child(3)': {
                width: '13%',
            },

            '&:last-child': {
                width: 56,
                borderRight: 'none',
                textAlign: 'center',
            },
        },
        td: {
            position: 'relative',
            padding: 10,
            verticalAlign: 'middle',

            '&:last-child': {
                borderRight: 'none',
                textAlign: 'center',
                opacity: 0,
                transition: 'opacity 0.3s',
            },
        },

        tr: {
            '&:hover': {
                td: {
                    padding: 10,

                    '&:last-child': {
                        opacity: '1',
                    },
                },
            },
        },
    },
    contextMenu: {
        position: 'absolute',
        top: 0,
        right: 0,
        backgroundColor: '#141414',
        borderRadius: 10,
        border: `1px solid ${colors.blackLight}`,
        padding: '1px 14px 10px 14px',
        zIndex: 1,
    },
    contextMenuItem: {
        marginTop: 9,
        cursor: 'pointer',
    },
    name: {
        display: 'flex',
        alignItems: 'center',
    },
    instanceIcon: {
        marginRight: 6,
    },
    selected: {
        opacity: '1 !important',
    },
    modalWrapper: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(0,0,0, 0.7)',
    },
    modalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        borderRadius: 20,
        padding: 30,
        color: colors.blackLight,
        lineHeight: 1.3,
        minWidth: 370,
    },
    modalTitle: {
        fontSize: 22,
        marginBottom: 30,
    },
    modalDescription: {
        marginBottom: 20,
        textAlign: 'center',
    },
    modalInputWrapper: {
        marginBottom: 20,
    },
    modalButtons: {
        display: 'flex',
        justifyContent: 'center',
    },
    modalButton: {
        margin: '0 6px',
    },
    downloadStatus: {
        position: 'absolute',
        right: 50,
        top: 38,
    },
    renameForm: {
        width: '100%',
    },
    renameInput: {
        padding: 0,
        background: 'none',
        color: colors.white,
        border: 'none',
        width: '100%',
    },
}

addStyles(fileManager)
export default fileManager
